<template>
<v-dialog
  :value="showModalContact"
  persistent
  @close="$emit('closeModal')"
  max-width="500"
  :content-class="'ModalContactManager'"
>
  <v-card class="ModalContactManager__card d-flex flex-column px-6 py-4">
    <div class="ModalContactManager__close d-flex justify-end">
      <v-btn
        small
        @click="$emit('closeModal')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="ModalContactManager__title">
      Свяжитесь с менеджером
    </div>

    <div class="ModalContactManager__body">
      Чтобы узнать подробности об акции или задать вопросы, свяжитесь с нашим менеджером в Telegram.
      Мы ответим вам в ближайшее время и поможем оформить скидку для вашей команды.
    </div>
    <div class="ModalContactManager__btn-group">
      <div>
        <v-btn
          class="mr-3 _w-100"
          outlined
          color="primary"
          @click="cancel"
        >
          Закрыть
        </v-btn>
      </div>
      <div>
        <v-btn
          class="_w-100"
          color="primary"
          @click="acceptSend"
        >
          Перейти в Телеграм
        </v-btn>
      </div>

    </div>
  </v-card>
</v-dialog>
</template>

<script>
/**
 * Компонент: ModalContactManager
 * Описание:
 */
export default {
  name: 'ModalContactManager',

  components: {},

  props: {
    showModalContact: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeModal', 'acceptSend'],
  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    acceptSend() {
      this.$emit('acceptSend');
    },
    cancel() {
      this.$emit('closeModal');
    }
  },
};
</script>

<style scoped lang="scss">
.ModalContactManager {
  &__card{
    border-radius: 20px !important;
    box-shadow: none !important;
    gap: 24px;
  }

  &__close{
    & > button{
      box-shadow: none !important;
      background: transparent;
    }
  }

  &__title {
    font-size: 22px;
    color: var(--color-blue-500);
    font-weight: 600;
    text-align: center;
  }

  &__btn-group{
    display: flex;
    justify-content: flex-end;
  }

}
</style>
